import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import { useState, useCallback } from 'react';
import config from '../config/frontend-config';

export const useJiraData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [issues, setIssues] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null); // todo: implement error case

  const { instance } = useMsal();

  console.log('here');

  const postJQLQuery = useCallback(async (jqlQuery) => {
    console.log('performing a post with ' + jqlQuery);
    setIsLoading(true);
    try {
      const tokenresponse = await instance.acquireTokenSilent({
        account: instance.getActiveAccount(),
        scopes: ['api://f1331b3b-4157-4d5a-9117-22f1ef20289f/frontend-admin'],
      });
      const response = await axios.post(
        `${config.backendUrl}/search`,
        { jql: jqlQuery },
        {
          headers: {
            Authorization: `Bearer ${tokenresponse.accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      setIsLoading(false);
      setIssues(response.data);

      console.log('response data: ', response.data);
    } catch (error) {
      setIsLoading(false);
      console.error('Error when posting the data', error);
    }
  }, [instance]);

  return { postJQLQuery, isLoading, issues, error };
};
